module.exports = __webpack_public_path__ + "img/angular.368685db.jpg";